import { withInstall } from '@ll-plus/utils'

import SecondConfirmation from './src/second-confirmation.vue'

export const LlSecondConfirmation = withInstall(SecondConfirmation)

export default LlSecondConfirmation

export * from './src/use-second-confirmation'

export * from './src/second-confirmation'

declare module 'vue' {
  export interface GlobalComponents {
    LlSecondConfirmation: typeof SecondConfirmation
  }
}
